import React, { useState, useEffect } from "react"
import { Outlet, useNavigate } from "react-router-dom"
import MainNavbar from "../components/MainNavbar"
import MainFooter from "../components/MainFooter"
import {
  setToastBoxDescription,
  setToastBoxStatus,
} from "../redux/ToastBoxSlice"
import { useDispatch } from "react-redux"

function MainLayout() {
  const [loggedIn, setLoggedIn] = useState(false)
  const navigate = useNavigate()
  const dispatch = useDispatch()

  useEffect(() => {
    setLoggedIn(Boolean(localStorage.getItem("userToken")))
  }, [])

  const handleLogout = () => {
    localStorage.removeItem("isLoggedIn")
    localStorage.removeItem("userName")
    localStorage.removeItem("userToken")
    dispatch(
      setToastBoxDescription(
        "You have been successfully logged out. If you need to login again please access from grinds360 platform."
      )
    )
    dispatch(setToastBoxStatus(true))
    setLoggedIn(false)
    navigate("/")
  }

  return (
    <div className='main-wrappper'>
      <MainNavbar loggedIn={loggedIn} handleLogout={handleLogout} />
      <Outlet />
      <MainFooter />
    </div>
  )
}

export default MainLayout
